// Todo: refactor completely

const Logger = require('./logger_utils');
const ObjectUtils = require('./object_utils');

const feedback = (method, success, request, cb, options = {}) => {
    let message = request.responseText;
    let headerString = options.returnHeaders && request.getAllResponseHeaders();

    if (method === 'post') {
        message = (ObjectUtils.isJsonString(message) ? JSON.parse(message) : message);
    }

    if (headerString) {
        const headers = parseHeaders(headerString);
        cb(success, {body: message, headers});
    } else {
        cb(success, message);
    }
};

const parseHeaders = (stringHeaders) => {
    const headerLines = stringHeaders.split('\n');
    let headers = {};
    for (let i = 0; i < headerLines.length; i++) {
        const headerLine = headerLines[i];
        if (headerLine.indexOf(':') > -1) {
            const headerValueSplit = headerLine.split(':');
            headers[headerValueSplit[0].trim()] = headerValueSplit[1].trim();
        }
    }
    return headers;
};

const prepareBody = (body) => {
    var params = JSON.stringify(body);
    if (body) params = params.replace(/%20/g, '+');
    return params;
};

const getFromOption = (options, prop) => {
    return typeof (options) === 'string' ? options : options[prop];
};

const handler = (method) => {
    return (options, cb) => {
        let params = null;
        const uri = getFromOption(options, 'uri');

        if (typeof cb !== 'function') {
            throw new Error('Callback must be function');
        }

        var request = new XMLHttpRequest();

        // OnSuccess
        request.addEventListener('load', function(response) {
            feedback(method, true, request, cb, options);
        }, false);

        // OnError
        request.addEventListener('error', function(ev) {
            Logger.error('An error occured when requesting: ' + uri);
            feedback(method, false, request, cb);
        }, false);

        if (options.body) {
            params = prepareBody(options.body);
        }

        // Prepare request
        request.open(method, uri, true);

        if (method === 'post') {
            request.setRequestHeader('Content-type', 'application/json; charset=utf-8');
        }

        if (options.headers) {
            for (var header in options.headers) {
                request.setRequestHeader(header, options.headers[header]);
            }
        }
        request.send(params);
    };
};

const HttpUtils = {};

['GET', 'POST', 'DELETE'].map(i => {
    const method = i.toLowerCase();
    HttpUtils[method] = handler(method);
});

HttpUtils.put = function(options, cb) {
    var request = new XMLHttpRequest();

    // OnSuccess
    request.addEventListener('load', function(ev) {
        cb(true, (ObjectUtils.isJsonString(request.responseText) ? JSON.parse(request.responseText) : request.responseText));
    }, false);

    // OnError
    request.addEventListener('error', function(ev) {
        cb(false, ev);
    }, false);

    // Prepare body
    if (options.body) {
        var params = JSON.stringify(options.body);
        params = params.replace(/%20/g, '+');
    }

    // Prepare request
    request.open('PUT', options.uri, true);

    request.setRequestHeader('Content-type', 'application/json; charset=utf-8');
    if (options.headers) {
        for (var header in options.headers) {
            request.setRequestHeader(header, options.headers[header]);
        }
    }

    // Send request
    request.send(params);
};

module.exports = HttpUtils;



// WEBPACK FOOTER //
// ./src/util/http_utils.js